import React from 'react';
import DomTemplate from '../../mainpage/domTemplate';
import shortid from 'shortid';

interface IFpDiscTextProps {
    fpDisc?: { data: {}, header: { data: {} } };
    onClick?: (e: any) => void;
}
class FpDiscText extends React.PureComponent<IFpDiscTextProps, any> {

    constructor(props: IFpDiscTextProps) {
        super(props);
    }

    public render() {
        const { fpDisc } = this.props;
        if (!fpDisc) return null;
        return (
            <>
                <div id='fpDisc-header' onClick={this.props.onClick}>
                    <DomTemplate sourceM={fpDisc ? fpDisc.header.data : null} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />
                </div>
                <div id='fpDisc-body'>
                    <DomTemplate sourceM={fpDisc ? fpDisc.data : null} dataStringM={'paragraph'} classNameM={''} key={shortid.generate()} />
                </div>
            </>
        );
    }
}
export default FpDiscText;
